import { Brain, Layers, Repeat, Compass, Sparkles, Users, Flame } from "lucide-react";

const ITEMS = [
  { icon: Brain, text: "You want to start but keep overthinking." },
  { icon: Layers, text: "You already have a business but lack structure." },
  { icon: Repeat, text: "You struggle with consistency." },
  { icon: Compass, text: "You want accountability and direction." },
  { icon: Sparkles, text: "You want to build your personal brand." },
  { icon: Users, text: "You want ambitious people around you." },
  { icon: Flame, text: "You're serious about changing your life through business." },
];

export const BuildDayWhoFor = () => {
  return (
    <section
      id="who-for-buildday"
      data-testid="buildday-whofor-section"
      className="relative bg-[#0A0A0C] py-24 md:py-40 border-t border-zinc-800"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16 md:mb-20">
          <div className="reveal flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#4F7CFF]" />
            <span className="text-xs tracking-[0.3em] uppercase text-[#4F7CFF] font-bold">
              The Fit
            </span>
          </div>
          <h2
            data-testid="buildday-whofor-headline"
            className="reveal text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-extrabold text-white leading-[1.02]"
          >
            This is for you{" "}
            <span className="italic font-light text-white">if…</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-zinc-800 border border-zinc-800">
          {ITEMS.map((item, i) => {
            const Icon = item.icon;
            const isLast = i === ITEMS.length - 1;
            return (
              <div
                key={i}
                data-testid={`buildday-whofor-card-${i + 1}`}
                className={`reveal group bg-[#15161B] hover:bg-[#1A1B22] transition-colors duration-500 p-8 md:p-10 ${
                  isLast ? "md:col-span-2 lg:col-span-3" : ""
                }`}
              >
                <div className="flex items-center justify-between mb-8">
                  <Icon
                    className="w-6 h-6 text-zinc-400 group-hover:text-[#4F7CFF] transition-colors duration-300"
                    strokeWidth={1.4}
                  />
                  <span className="text-xs tracking-[0.25em] uppercase text-zinc-700 font-bold">
                    0{i + 1}
                  </span>
                </div>
                <p className="text-lg md:text-xl leading-snug text-white font-semibold tracking-tight">
                  {item.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
